export default __webpack_public_path__ + "static/media/image10.db0a4e46.png";